import { createEnv } from '@t3-oss/env-core'
import * as v from 'valibot'
import { ensureSlash } from './lib/ensure-slash'

export const env = createEnv({
	server: {
		SERVER_URL: v.optional(v.pipe(v.string(), v.url())),
	},

	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: 'VITE_',

	client: {
		VITE_APP_TITLE: v.optional(
			v.pipe(
				v.string(),
				v.transform((value) => value.trim()),
				v.minLength(1),
			),
		),
		VITE_APP_VERSION: v.optional(v.string()),
		VITE_APP_DEPLOY: v.optional(v.string()),
		VITE_CONFIG_PATH: v.optional(
			v.string(),
			globalThis.__CONFIG_JSON_PATH || '/config.json',
		),
		VITE_API_URL: v.optional(
			v.string(),
			`${ensureSlash(globalThis.__BASE_URL)}api/`,
		),
		VITE_SIGNALR_HUB_URL: v.optional(v.string(), ''),
		VITE_OIDC_ISSUER_URI: v.optional(v.string(), ''),
		VITE_OIDC_CLIENT_ID: v.optional(v.string(), ''),
		VITE_OIDC_REDIRECT_URI: v.optional(v.string(), ''),
		VITE_OIDC_SCOPE: v.optional(v.string(), ''),

		VITE_AUTH_TOKEN: v.optional(v.string(), ''),
	},

	/**
	 * What object holds the environment variables at runtime. This is usually
	 * `process.env` or `import.meta.env`.
	 */
	runtimeEnv: __ENV,

	/**
	 * By default, this library will feed the environment variables directly to
	 * the valibot validator.
	 *
	 * This means that if you have an empty string for a value that is supposed
	 * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
	 * it as a type mismatch violation. Additionally, if you have an empty string
	 * for a value that is supposed to be a string with a default value (e.g.
	 * `entity=` in an ".env" file), the default value will never be applied.
	 *
	 * In order to solve these issues, we recommend that all new projects
	 * explicitly specify this option as true.
	 */
	emptyStringAsUndefined: true,
})
